(function() {
  function normalisePredictiveQuery(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : '';
  }

  function expandSearchQuery(query) {
    var compactQuery = query.replace(/[\s_-]+/g, '');
    var aliases = {
      adj: 'adjustable',
      adju: 'adjustable',
      adjustble: 'adjustable',
      ajustable: 'adjustable',
      mat: 'mattress',
      mats: 'mattress',
      matress: 'mattress',
      dbl: 'double',
      tel: 'telescoping',
      telesc: 'telescoping',
      teliscoping: 'telescoping',
      telescpoing: 'telescoping',
      '2in1': '2 in 1',
      '3in1': '3 in 1'
    };

    return aliases[query] || aliases[compactQuery] || query;
  }

  function serialiseParams(obj) {
    return Object.keys(obj).map(function(key) {
      return key + '=' + encodeURIComponent(obj[key]);
    }).join('&');
  }

  function patchPredictiveSearch() {
    if (!window.theme || !theme.predictiveSearch || !theme.routes || !theme.routes.predictive_url) {
      return;
    }

    var form = document.getElementById('HeaderSearchForm');
    var wrapper = document.getElementById('PredictiveWrapper');
    var results = document.getElementById('PredictiveResults');

    if (!form || !wrapper || !results || form.dataset.searchSuggestionsPatched === 'true') {
      return;
    }

    form.dataset.searchSuggestionsPatched = 'true';

    var input = form.querySelector('input[type="search"]');
    var button = wrapper.querySelector('[data-predictive-search-button]');
    var currentQuery = '';
    var searchTimer;
    var activeRequest = null;
    var requestId = 0;

    function reset() {
      if (activeRequest) {
        activeRequest.abort();
        activeRequest = null;
      }
      wrapper.classList.add('hide');
      results.innerHTML = '';
      clearTimeout(searchTimer);
    }

    function submitSearch(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      var params = new URLSearchParams(new FormData(form));
      params.set('q', expandSearchQuery(normalisePredictiveQuery(input.value)));

      window.location.href = theme.routes.search + '?' + params.toString();
      return false;
    }

    function fetchResults(query) {
      currentQuery = query;
      var requestQuery = expandSearchQuery(query);

      if (activeRequest) {
        activeRequest.abort();
      }

      activeRequest = new AbortController();
      requestId += 1;
      var thisRequestId = requestId;

      var searchObj = {
        q: requestQuery,
        'resources[type]': 'product,query',
        'resources[limit]': 10,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };

      fetch(theme.routes.predictive_url + '?' + serialiseParams(searchObj) + '&section_id=predictive-search', {
        signal: activeRequest.signal
      })
        .then(function(response) {
          return response.text().then(function(text) {
            if (!response.ok) {
              throw new Error(response.status + ': ' + text);
            }
            return text;
          });
        })
        .then(function(text) {
          if (thisRequestId !== requestId || normalisePredictiveQuery(input.value) !== query) {
            return;
          }

          var section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');

          if (!section || section.innerHTML.replace(/\s+/g, '') === '') {
            reset();
            return;
          }

          results.innerHTML = section.innerHTML;
          wrapper.classList.remove('hide');
        })
        .catch(function(error) {
          if (error.name === 'AbortError') {
            return;
          }
          console.error(error);
        });
    }

    function search() {
      var query = normalisePredictiveQuery(input.value);

      if (!query) {
        reset();
        currentQuery = '';
        return;
      }

      clearTimeout(searchTimer);
      searchTimer = setTimeout(function() {
        fetchResults(query);
      }, 200);
    }

    form.addEventListener('submit', submitSearch, true);

    if (button) {
      button.addEventListener('click', submitSearch, true);
    }

    if (input) {
      input.addEventListener('input', search);
      input.addEventListener('keyup', function(evt) {
        if ([9, 38, 40].indexOf(evt.keyCode) === -1) {
          evt.stopImmediatePropagation();
          search();
        }
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchPredictiveSearch);
  } else {
    patchPredictiveSearch();
  }

  document.addEventListener('page:loaded', patchPredictiveSearch);
})();
